import styled from 'styled-components';

import ExternTitle from 'components/ExternTitle';

export const Title = styled(ExternTitle)`
  margin-bottom: 60px;
  @media (max-width: 991px) {
    margin-bottom: 30px;
  }
  @media (max-width: 400px) {
    hyphens: auto;
  }
`;

export const Introduction = styled.div`
  column-count: 2;
  column-gap: 15px;
  @media (max-width: 991px) {
    column-count: 1;
  }
`;

export const SubTitle = styled(Title)`
  margin: 120px 0 30px;
  @media (max-width: 991px) {
    margin-top: 60px;
  }
`;
